import { AirwallexTransferStatus } from '@40seas/entities/airwallex';
import { EnumColor } from '@40seas/frontend/common/providers';

export const airwallexTransferStatusColorMapping = {
    [AirwallexTransferStatus.Blocked]: 'error',
    [AirwallexTransferStatus.Canceled]: 'error',
    [AirwallexTransferStatus.Done]: 'success',
    [AirwallexTransferStatus.Failed]: 'error',
    [AirwallexTransferStatus.InProgress]: 'info',
    [AirwallexTransferStatus.Initiated]: 'info',
    [AirwallexTransferStatus.Pending]: 'default',
} as { [key in AirwallexTransferStatus]: EnumColor };
